/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

export default angular.module('tektelic.api.device', [])
    .factory('deviceService', DeviceService)
    .name;

/*@ngInject*/
function DeviceService($http, $q, types, wsSubscriptionService) {

    var service = {
        deleteDevice: deleteDevice,
        deleteSystemDevice: deleteSystemDevice,
        getDevice: getDevice,
        getDeviceFCnts: getDeviceFCnts,
        getDevicePackages: getDevicePackages,
        getDevicePackagesWithTimeRange: getDevicePackagesWithTimeRange,
        saveDevice: saveDevice,
        saveDeviceBulkProvisioning: saveDeviceBulkProvisioning,
        saveDeviceFCnts: saveDeviceFCnts,
        requestDeviceStatus: requestDeviceStatus,
        getApplicationDevices: getApplicationDevices,
        getMulticastGroupDevices: getMulticastGroupDevices,
        getCustomerDevices: getCustomerDevices,
        getSubCustomerDevices: getSubCustomerDevices,
        getCustomerDeviceFilterValues: getCustomerDeviceFilterValues,
        getSubCustomerDeviceFilterValues: getSubCustomerDeviceFilterValues,
        subscribeForDeviceStateData: subscribeForDeviceStateData,
        subscribeForDeviceStatsData: subscribeForDeviceStatsData,
        getSystemDeviceByEui: getSystemDeviceByEui,
        isAbpEnabled: isAbpEnabled,
        getDownlinkQueue: getDownlinkQueue,
        clearDownlinkQueue: clearDownlinkQueue,
        postDownlinkToQueue: postDownlinkToQueue,
        getDeviceMulticastGroups: getDeviceMulticastGroups,
        getUniqueDevAddress: getUniqueDevAddress,
        getSession: getSession,
        setSession: setSession
    };

    return service;

    function getApplicationDevices(applicationId, limit, page, sortField, sortDirection, filter) {
        var deferred = $q.defer();
        var path = `/api/application/${applicationId}/devices?limit=${limit}&page=${page}&sortField=${sortField}&sortDirection=${sortDirection}`
        if (filter) {
            path += `&filter=${encodeURIComponent(filter)}`
        }
        $http.get(path, null)
            .then(function success(response) {
                deferred.resolve(response.data, response.totalElements);
            }, function fail() {
                deferred.reject();
            });
        return deferred.promise;
    }

    function getMulticastGroupDevices(multicastGroupId, limit, page, sortField, sortDirection, filter) {
        var deferred = $q.defer();
        var path = `/api/multicastGroup/${multicastGroupId}/devices?limit=${limit}&page=${page}&sortField=${sortField}&sortDirection=${sortDirection}`
        if (filter) {
            path += `&filter=${encodeURIComponent(filter)}`
        }
        $http.get(path, null)
            .then(function success(response) {
                deferred.resolve({data: response.data, totalElements: response.data.length});
            }, function fail() {
                deferred.reject();
            });
        return deferred.promise;
    }

    function getDeviceMulticastGroups(deviceId) {
        var deferred = $q.defer();
        var path = `/api/device/${deviceId}/multicastGroups`;
        $http.get(path, null)
            .then(function success(response) {
                deferred.resolve(response.data);
            }, function fail() {
                deferred.reject();
            });
        return deferred.promise;
    }

    function getCustomerDevices(customerId, limit, page, sortField, sortDirection, filter, deviceModel, active) {
        var deferred = $q.defer();
        var path = `/api/customer/${customerId}/devices?limit=${limit}&page=${page}&sortField=${sortField}&sortDirection=${sortDirection}`
        if (filter) {
            path += `&filter=${encodeURIComponent(filter)}`
        }
        path += buildColumnFilterParams(deviceModel, active);
        $http.get(path, null)
            .then(function success(response) {
                deferred.resolve(response.data, response.totalElements);
            }, function fail() {
                deferred.reject();
            });
        return deferred.promise;
    }

    function getSubCustomerDevices(subCustomerId, limit, page, sortField, sortDirection, filter, deviceModel, active) {
        var deferred = $q.defer();
        var path = `/api/subCustomer/${subCustomerId}/devices?limit=${limit}&page=${page}&sortField=${sortField}&sortDirection=${sortDirection}`
        if (filter) {
            path += `&filter=${encodeURIComponent(filter)}`
        }
        path += buildColumnFilterParams(deviceModel, active);
        $http.get(path, null)
            .then(function success(response) {
                deferred.resolve(response.data, response.totalElements);
            }, function fail() {
                deferred.reject();
            });
        return deferred.promise;
    }

    function buildColumnFilterParams(deviceModel, active) {
        var params = '';
        if (deviceModel && deviceModel.length) {
            params += `&deviceModel=${deviceModel.map(encodeURIComponent).join(',')}`;
        }
        if (active && active.length) {
            params += `&active=${active.join(',')}`;
        }
        return params;
    }

    function getCustomerDeviceFilterValues(customerId) {
        var deferred = $q.defer();
        $http.get(`/api/customer/${customerId}/devices/filterValues`, null)
            .then(function success(response) {
                deferred.resolve(response.data);
            }, function fail() {
                deferred.reject();
            });
        return deferred.promise;
    }

    function getSubCustomerDeviceFilterValues(subCustomerId) {
        var deferred = $q.defer();
        $http.get(`/api/subCustomer/${subCustomerId}/devices/filterValues`, null)
            .then(function success(response) {
                deferred.resolve(response.data);
            }, function fail() {
                deferred.reject();
            });
        return deferred.promise;
    }

    function getDevice (deviceId) {
        var deferred = $q.defer();
        var url = '/api/device/' + deviceId;
        $http.get(url, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getDeviceFCnts (deviceId) {
        var deferred = $q.defer();
        var url = '/api/device/' + deviceId + '/fcnts';
        $http.get(url, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getDevicePackages (deviceId, limit, lastMillis, lastIndex) {
        var deferred = $q.defer();
        var url = '/api/device/' + deviceId + `/log?lastMillis=${lastMillis}&limit=${limit}&lastIndex=${lastIndex}`;
        $http.get(url, {ignoreLoading: true}).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getDevicePackagesWithTimeRange (deviceId, fromMillis, toMillis, limit=1000) {
        var deferred = $q.defer();
        var url = '/api/v2/device/' + deviceId + `/log?fromMillis=${fromMillis}&toMillis=${toMillis}&limit=${limit}`;
        $http.get(url, {ignoreLoading: true}).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function saveDevice (device) {
        var deferred = $q.defer();
        var url = '/api/device';
        $http.post(url, device).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function saveDeviceBulkProvisioning(device) {
        var deferred = $q.defer();
        var url = '/api/device';
        $http.post(url, device, {ignoreErrors: true}).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail(rejection) {
            deferred.reject(rejection);
        });
        return deferred.promise;
    }

    function saveDeviceFCnts (deviceId, deviceFCnts) {
        var deferred = $q.defer();
        if (!deviceFCnts) {
            deviceFCnts = {};
        }
        var url = '/api/device/' + deviceId + '/fcnts';
        $http.post(url, deviceFCnts).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function requestDeviceStatus(deviceId) {
        var deferred = $q.defer();
        var url = `/api/macCommand/${deviceId}/devStatus`;
        $http.post(url, null).then(function success() {
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function deleteDevice (deviceId) {
        var deferred = $q.defer();
        var url = '/api/device/' + deviceId;
        $http.delete(url).then(function success() {
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function deleteSystemDevice (deviceId) {
        var deferred = $q.defer();
        var url = '/api/system/device/' + deviceId;
        $http.delete(url).then(function success() {
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function subscribeForDeviceStateData(deviceId, onData) {
        var subscriptionCommand = {
            entityType: types.entityType.device,
            entityId: deviceId,
            type: types.wsSubscriptionType.state
        };
        var subscriber = {
            subscriptionCommand: subscriptionCommand,
            onData: function (data) {
                if (data.data) {
                    onData(data.data);
                }
            }
        };
        return wsSubscriptionService.subscribe(subscriber);
    }

    function subscribeForDeviceStatsData(deviceId, onStatsData, onReconnected) {
        var subscriptionCommand = {
            entityType: types.entityType.device,
            entityId: deviceId,
            type: types.wsSubscriptionType.stats
        };
        var subscriber = {
            subscriptionCommand: subscriptionCommand,
            onData: function (data) {
                if (data.data) {
                    onStatsData(data.data);
                }
            },
            onReconnected: function () {
                if (onReconnected) {
                    onReconnected();
                }
            }
        };
        return wsSubscriptionService.subscribe(subscriber);
    }

    function getSystemDeviceByEui(deviceEui) {
        var deferred = $q.defer();

        $http.get('/api/system/device/eui/' + deviceEui).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });

        return deferred.promise;
    }

    function isAbpEnabled(device) {
        return device && (
            (device.useAppNetworkSettings && device.applicationAbp) ||
            (!device.useAppNetworkSettings && device.abp));
    }

    function getDownlinkQueue(deviceId) {
        var deferred = $q.defer();
        $http.get(`/api/device/${deviceId}/downlink`).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });

        return deferred.promise;
    }

    function postDownlinkToQueue (deviceId, downlink) {
        var deferred = $q.defer();
        var url = `/api/device/${deviceId}/downlink`;
        $http.post(url, downlink).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function clearDownlinkQueue(deviceId) {
        var deferred = $q.defer();
        $http.delete(`/api/device/${deviceId}/downlink`).then(function success() {
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getUniqueDevAddress() {
        var deferred = $q.defer();
        var url = '/api/newUniqueDevAddress';
        $http.get(url, {headers: { 'Accept': "text/plain" }})
        .then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getSession(deviceId) {
        var deferred = $q.defer();
        var url = `/api/device/${deviceId}/session`;
        $http.get(url, { ignoreErrors: true }).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function setSession(deviceId, settings) {
        var deferred = $q.defer();
        var url = `/api/device/${deviceId}/session`;
        $http.patch(url, settings).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

}



// WEBPACK FOOTER //
// ./src/app/api/device.service.js